import { defineStore } from 'pinia'

export const useFileStore = defineStore('media', {
  actions: {
    async sendFiles(files) {
      const token = localStorage.getItem('token')

      const body = files.map(el => ({
        name: el.name,
        type: el.type,
        size: el.size,
        lastModified: el.lastModified,
        content: el.content,
      }))

      try {
        const response = await useApi(`api/media/mass-upload-only`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: {
            files: body
          },
        })
        return response.data
      } catch (error) {
        console.error('Failed to fetch permissions:', error)
        return []
      }
    },
  },
})
